import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

export function useJobCards(params) {
  const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== '' && v != null));
  const qs = new URLSearchParams(clean).toString();
  return useQuery({
    queryKey: ['jobCards', clean],
    queryFn: async () => (await api.get(`/api/job-cards?${qs}`)).data,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchInterval: 120000,
  });
}

export function useSyncJobCards() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => (await api.post('/api/job-cards/sync')).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['jobCards'] }),
  });
}

// The escape-hatch queue. Engineers who could not see their job claim it by WO
// number from the app; every row is an assignment that did not reach the person
// who actually did the work. Same refresh cadence as the board.
export function useJobClaims(status = 'open') {
  return useQuery({
    queryKey: ['jobClaims', status],
    queryFn: async () => (await api.get(`/api/job-cards/claims?status=${status}`)).data,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchInterval: 120000,
  });
}

export function useSetClaimStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, action }) => (await api.post(`/api/job-cards/claims/${id}/${action}`)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['jobClaims'] }),
  });
}

// Weekly stock-logging compliance, Monday to Friday. `week` is any date in
// the week; the server snaps it back to that Monday, so callers never have
// to agree with it about where a week starts.
export function useStockWeek(week) {
  return useQuery({
    queryKey: ['jobCards', 'stock-week', week],
    queryFn: async () => (await api.get(`/api/job-cards/stock-week?week=${week}`)).data,
    staleTime: 60000,
  });
}
